import * as React from 'react';
import { connect } from 'react-redux';

import { SearchTags } from '../../../../common/components/search_tags';
import { Dispatch, IAppState } from '../../../../common/state';
import { wordIncludeAdded, wordIncludeRemoved } from '../../../state/advanced/words_include';
import { InlineParam, Row } from '../markup';

interface IWordsIncludeProps {
  wordsInclude: string[];
  isModerator: boolean;
  onWordIncludeAdded(word: string): void;
  onWordIncludeRemoved(word: string): void;
}

export const WordsInclude: React.FC<IWordsIncludeProps> = props => (
  <Row title="Содержит слова">
    <InlineParam>
      <SearchTags
        isModerator={props.isModerator}
        words={props.wordsInclude}
        onWordAdded={word => props.onWordIncludeAdded(word)}
        onWordRemoved={word => props.onWordIncludeRemoved(word)}
        tagStyle={{ backgroundColor: 'rgba(45,160,1,.2)', color: '#121212' }}
      />
    </InlineParam>
  </Row>
);

export const mapStateToProps = (state: IAppState) => ({
  wordsInclude:
    (state.filters.jsonQuery.description_include && state.filters.jsonQuery.description_include.value) || [],
  isModerator: state.user.isAuthenticated && state.user.isModerator,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onWordIncludeAdded: (word: string) => {
    dispatch(wordIncludeAdded(word));
  },
  onWordIncludeRemoved: (word: string) => {
    dispatch(wordIncludeRemoved(word));
  },
});

// tslint:disable-next-line:no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(WordsInclude);
